// import { deepClone } from '@/utils/utils';

// export const RECOMMEND_CHART_OPTION = {
//   visualMap: {
//     min: 0,
//     max: 5,
//     left: 'auto',
//     bottom: 'auto',
//     showLabel: true,
//     pieces: [
//       {
//         value: 5,
//         color: '#FF7247',
//       },
//       {
//         value: 4,
//         color: '#FF9822',
//       },
//       {
//         value: 3,
//         color: '#FCBC18',
//       },
//       {
//         value: 2,
//         color: '#FFD69C',
//       },
//       {
//         value: 1,
//         color: '#FFEF9B',
//       },
//       {
//         value: 0,
//         color: '#FFFFFF',
//       },
//     ],
//     show: false,
//   },
//   tooltip: {
//     trigger: 'item',
//     backgroundColor: '#ffffff',
//     borderWidth: 1,
//     borderColor: '#ccc',
//     extraCssText: 'box-shadow: 0rem 0.08rem 0.2rem 0rem rgba(0,0,0,0.0500);border-radius: 0.16rem;',
//     textStyle: {
//       color: '#333333',
//     },
//     padding: [15, 10],
//     formatter: function(params, ticket, callback) {
//       setTimeout(() => {
//         callback(
//           ticket,
//           `<div><h2 style="color: #D5AB6D;">200M≤单线最低≤500M</h2><p>地区奖励：15%</p><p>合计奖励最高：</p></div>`
//         );
//       }, 2000);
//       return '加载中....';
//     },
//   },
//   geo: {
//     map: 'china',
//     // 控制地图缩放与平移
//     roam: true,
//     silent: false,
//     scaleLimit: {
//       min: 1,
//       max: 3,
//     },
//     zoom: 1.23,
//     label: {
//       normal: {
//         show: !0,
//         fontSize: '10',
//         color: 'rgba(0,0,0,0.7)',
//       },
//     },
//     itemStyle: {
//       normal: {
//         //shadowBlur: 50,
//         //shadowColor: 'rgba(0, 0, 0, 0.2)',
//         borderColor: 'rgba(0, 0, 0, 0.2)',
//       },
//     },
//   },
//   series: [
//     {
//       name: '上机推荐',
//       type: 'map',
//       map: 'chaina',
//       geoIndex: 0,
//       data: [],
//     },
//   ],
// };

export const BASIC_CONFIG = {
  visualMap: {
    min: 0,
    max: 6,
    left: 'auto',
    bottom: 'auto',
    showLabel: true,
    pieces: [
      {
        gte: 8,
        color: '#CC2F00',
      },
      {
        value: 7,
        color: '#F5440F',
      },
      {
        value: 6,
        color: '#FF6E23',
      },
      {
        value: 5,
        color: '#FF9822',
      },
      {
        value: 4,
        color: '#FFB700',
      },
      {
        value: 3,
        color: '#FFCC2C',
      },
      {
        value: 2,
        color: '#FFD69C',
      },
      {
        value: 1,
        color: '#FFEA9C',
      },
      {
        lte: 0,
        color: '#EDEEEF',
      },
    ],
    show: false,
  },
  tooltip: {
    trigger: 'item',
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: '#ccc',
    extraCssText: 'box-shadow: 0rem 0.08rem 0.2rem 0rem rgba(0,0,0,0.0500);border-radius: 0.16rem;',
    textStyle: {
      color: '#333333',
      fontSize: 12,
      lineHeight: 17,
    },
    formatter: '{b}',
    padding: [15, 10],
  },
  geo: {
    map: 'china',
    // 控制地图缩放与平移
    roam: false,
    silent: true,
    scaleLimit: {
      min: 1,
      max: 3,
    },
    zoom: 1.23,
    label: {
      normal: {
        show: !0,
        fontSize: '10',
        color: 'rgba(0,0,0,0.7)',
      },
    },
    itemStyle: {
      normal: {
        areaColor: '#EDEEEF',
        borderColor: 'rgba(0, 0, 0, 0.2)',
      },
    },
    emphasis: {
      itemStyle: {
        areaColor: '#D5AB6D',
        borderColor: 'rgba(174, 135, 76, 0.5)',
      },
    },
  },
  series: [
    {
      name: '上机推荐',
      type: 'map',
      map: 'china',
      geoIndex: 0,
      data: [],
    },
  ],
};

export const LOADING_CONFIGF = {
  text: '加载中…',
  color: '#D5A661',
  textColor: '#333',
  // maskColor: 'rgba(0, 0, 0, 0.5)',
  maskColor: 'rgba(255, 255, 255, 0.5)',
  zlevel: 1,
  // 字体大小。从 `v4.8.0` 开始支持。
  fontSize: 14,
  // 是否显示旋转动画（spinner）。从 `v4.8.0` 开始支持。
  showSpinner: true,
  // 旋转动画（spinner）的半径。从 `v4.8.0` 开始支持。
  spinnerRadius: 10,
  // 旋转动画（spinner）的线宽。从 `v4.8.0` 开始支持。
  lineWidth: 2,
};

// export const setRecommendChartOptions = (name, config = {}) => {
//   const PREV_CONFIG = deepClone(BASIC_CONFIG);
//   if (!name) return PREV_CONFIG;
//   if (!PREV_CONFIG[name]) PREV_CONFIG[name] = {};
//   if (name === 'series') {
//     PREV_CONFIG.series[0].data = config;
//     return PREV_CONFIG;
//   }
//   return {
//     ...PREV_CONFIG,
//     [name]: { ...PREV_CONFIG[name], ...config },
//   };
// };
